import { render } from "./Intermediary.vue?vue&type=template&id=3e1cc061&scoped=true"
import script from "./Intermediary.vue?vue&type=script&lang=js"
export * from "./Intermediary.vue?vue&type=script&lang=js"

import "./Intermediary.vue?vue&type=style&index=0&id=3e1cc061&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1cc061"]])

export default __exports__